import { render } from "./componentEditAperio.vue?vue&type=template&id=206f6339"
import script from "./componentEditAperio.vue?vue&type=script&lang=js"
export * from "./componentEditAperio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__